import React from 'react';

export default function DashboardLayout({ children }) {
  return (
    <div className="dashboard-root">
      <main className="dashboard-main">
        {children}
      </main>
    </div>
  );
}
